import Model from "../../utils/RestModel.js";
import Field from "../../utils/Field.js";
import App from "./App.js";
import Product from "./Product.js";
import Stock from "./Stock.js";
import NamedTimePeriod from "./NamedTimePeriod.js";
import getYearQuarter from "../../utils/getYearQuarter.js";
import Linguist from "../../../lib/JuiS/Linguist.js";
import stockReservationLexicons from "./lexicons/stock-reservation/stockReservationLexicons.js";
import {createLink} from "../../bulma_components/Link.js";
import BULMA_CSS_CLASSES from "../../bulma_components/bulmaCssClasses.js";
import Container from "juis-components/Container.js";
import {createIcon} from "../../bulma_components/Icon.js";
import getStockChangeCell from "../components/table-cells/getStockChangeCell.js";

const linguist = new Linguist(stockReservationLexicons);
export default new Model(function () {
    this.app = new Field(App);
    this.product = new Field(Product).withLabel("Product");
    this.stock = new Field(Stock).withLabel("Stock");
    this.change = new Field().asNumber()
        .withCellFactory((change, reservation) => getStockChangeCell(change, reservation.product))
        .withLabel("Change");

    this.stockQuantity = new Field().asNumber().withLabel("In Stock")
        .withCellFactory(function (stockQuantity, reservation) {
            return new Container(function () {

                if (stockQuantity + reservation.change < 0) {
                    this.icon = createIcon("triangle-exclamation", BULMA_CSS_CLASSES.TYPOGRAPHY.HAS_TEXT_WARNING);
                }
                let unit = "";
                if (reservation.product && reservation.product.unit) {
                    unit = " " + reservation.product.unit;
                }
                this.link = createLink(`/${reservation.stock.app.code}/stocks/${reservation.stock.code}`, stockQuantity + unit);
            }, [BULMA_CSS_CLASSES.HAS_TEXT_RIGHT]);

        });
    this.day = new Field().asTimestamp("default", {year: "numeric", month: "long", day: "numeric"});
    this.week = new Field().asTimestamp("default", {year: "numeric", month: "long", day: "numeric"});
    this.month = new Field().asTimestamp("default", {year: "numeric", month: "long"});
    this.quarter = new Field().asTimestamp().withCellFactory(getYearQuarter);
    this.year = new Field().asTimestamp("default", {year: "numeric"});
    this.period = new Field(NamedTimePeriod).withLabel("Period");
    linguist.withAudience(this);
}, "Stock Reservation", "stock-reservations");


